import {Routes, Route, Navigate} from 'react-router-dom'
import {Suspense} from 'react'
import {LoaderOverlay} from '@components/ModernLoader.jsx'
import {routes} from './routesConfig.jsx'
import RequireAuth from '@components/routing/RequireAuth.jsx'
import useAuthSessionWatcher from '@hooks/useAuthSessionWatcher.js'
import useOnboardingBootstrap from '@hooks/useOnboardingBootstrap.js'
import ScrollToTop from './ScrollToTop.jsx'

function renderRoutes(routeList) {
    return routeList.map(({path, element, children, protected: isProtected, index}) => {
        const wrapped = isProtected ? (
            <RequireAuth>{element}</RequireAuth>
        ) : (
            element
        )

        return (
            <Route key={path || 'index'} path={path} index={index} element={wrapped}>
                {children ? renderRoutes(children) : null}
            </Route>
        )
    })
}

export default function AppRouter() {
    useAuthSessionWatcher()
    useOnboardingBootstrap()

    return (
        <Suspense fallback={<LoaderOverlay/>}>
            <ScrollToTop />
            <Routes>
                {renderRoutes(routes)}
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Routes>
        </Suspense>
    )
}
